import React from 'react'
import { Modal, Card } from '@scentregroup/ui'
import style from './index.module.scss'

interface IDialogA11y {
  label?: string
  labelledby?: string
  describedby?: string
}

export interface IDialog {
  isOpen: boolean
  onDismissButtonClick: () => void
  a11y: IDialogA11y
  shouldCloseOnOverlayClick?: boolean
  containerSize?: 'small' | 'medium' | 'large'
  dialogId?: string
}

const Dialog: React.FunctionComponent<React.PropsWithChildren<IDialog>> = ({
  isOpen,
  onDismissButtonClick,
  a11y,
  children,
  shouldCloseOnOverlayClick = true,
  containerSize = 'small',
  dialogId,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      containerSize={containerSize}
      onDismissButtonClick={onDismissButtonClick}
      internalDismiss={true}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      a11y={a11y}
      classNames={{
        overlay: style.modalOverlay,
        content: style.modalContent,
        icon: style.icon,
      }}
      dialogId={dialogId}
    >
      <Card className={style.content}>{children}</Card>
    </Modal>
  )
}

export default Dialog
